"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../atoms/Text"));
var _Icon = require("../atoms/Icon");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _flexComponents = require("../atoms/flex-components");
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "NoticeBanner__IconContainer",
  componentId: "sc-1xmw3ik-0"
})(["margin-bottom:auto;"]);
var NoticeBannerWrapper = _styledComponents.default.div.withConfig({
  displayName: "NoticeBanner__NoticeBannerWrapper",
  componentId: "sc-1xmw3ik-1"
})(["padding:", ";border:2px ", " solid;border-radius:", ";background:", ";"], _styles.spacing.m, function (props) {
  return _styles.colors.border.noticeBanner[props.type];
}, _styles.borderRadius.m, function (props) {
  return _styles.colors.background.noticeBanner[props.type];
});
var NoticeBannerTypes = {
  warning: 'warning',
  alert: 'alert',
  notice: 'notice'
};
var NoticeBanner = function NoticeBanner(_ref) {
  var body = _ref.children,
    type = _ref.type,
    title = _ref.title;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(NoticeBannerWrapper, {
    type: type,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexRow, {
      gap: 'm',
      children: [type === NoticeBannerTypes.warning ? /*#__PURE__*/(0, _jsxRuntime.jsx)(IconContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'warning',
          color: 'error',
          size: 'l'
        })
      }) : type === NoticeBannerTypes.alert ? /*#__PURE__*/(0, _jsxRuntime.jsx)(IconContainer, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'alert',
          color: 'primary',
          size: 'l'
        })
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexColumn, {
        gap: 'xs',
        children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: 'heading',
          variant: 'm',
          children: title
        }), body]
      })]
    })
  });
};
NoticeBanner.defaultProps = {
  type: NoticeBannerTypes.notice
};
var _default = exports.default = NoticeBanner;